import { useTexts } from "Components/TextContext";
import { Button as CommonButtonText } from "Components/TextContext/commonComponentEnums";
import { ThemedButton } from "Components/Themes/components/ThemedButton";
import { buttonNextTrackId } from "Utils/analytics";
import React from "react";

export const ContactMeButton = (): React.ReactElement => {
  const { getText } = useTexts();

  return (
    <ThemedButton
      as="a"
      href="https://cloud.email.storebrand.no/ssxkontaktmeg"
      target="_blank"
      id={buttonNextTrackId("contact-me")}
      type="button"
      variant="text"
      trackId={buttonNextTrackId("contact-me")}
      style={{ justifyContent: "left", paddingLeft: "0" }}
      iconRight={"arrow-right"}
    >
      {getText(CommonButtonText.CONTACT_ME)}
    </ThemedButton>
  );
};
